import styled from 'styled-components'
import { Card } from 'componentsV2/Card'

const LightGreyCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.colors?.background};
  background-color: ${({ theme }) => theme.colors?.background};
`

export default LightGreyCard
